// extracted by mini-css-extract-plugin
export default {"copy":"styles__copy--f858091b3a5ed2ed06b6"};